<router-outlet></router-outlet>
@if (loadingAction.value.loading) {
<app-overlay [message]="loadingAction.value.message" [subTitle]="loadingAction.value.subTitle"
    [loaderBar]="loadingAction.value.loaderBar" [exitUrl]="loadingAction.value.exitUrl"
    [success]="loadingAction.value.success" />
}

<!-- Banner Cookie Consent -->
@if (showCookieBanner) {
<div class="cookie-banner" [class.fade-in]="showCookieBanner" [class.fade-out]="!showCookieBanner">
    <div class="cookie-content">
        <div class="cookie-text" [innerHTML]="'COOKIE_CONSENT_MESSAGE' | translate:{ url: privacyUrl }"></div>
        <button class="cookie-btn" (click)="acceptCookies()">{{ 'CLOSE' | translate }}</button>
    </div>
</div>
}